import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {COMPANY_TYPE} from '../../../constants/Lookup';

const initialData = {
  summaryData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  addLetterStatus: null,
  postParameterId: null,
  summaryMsg: null,
  companyCodeData: {},
  clientCodeData: {},
  letterNumberDetails: {},
  letterGroupDropdownData: [],
  summaryLetters: [],
  letterMaintainPrintStatus: null,
  maintainLetterUsageData: {},
  userMetrix: '',
  addLetterdataStatus: null,
  addRecordData: {},
  addSuccessMsg: null,
};

const slice = createSlice({
  name: 'addLetterData',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSummaryData: (state, action) => {
      state.summaryData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSummaryLetterData: (state, action) => {
      state.summaryLetters = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getLetterGroupData: (state, action) => {
      state.letterGroupDropdownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message;
      state.isLoading = false;
    },
    postLetterData: (state, action) => {
      state.addLetterStatus = action.payload?.status;
      state.postParameterId = action.payload?.response?.letterParameterId;
      state.isLoading = false;
      state.errorMsg = null;
      state.summaryMsg = action.payload?.message;
      state.summaryData = action?.payload?.response || {};
      state.userMetrix = action.payload.response.userMetrix;
    },
    postLetterTypeAddData: (state, action) => {
      state.addLetterdataStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRecordData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    setMaintainLetterUsageData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.maintainLetterUsageData = action.payload;
    },
    postLetterNumberData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.letterNumberDetails = action.payload;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.message ? action.payload.message : action?.payload?.data?.error ? action?.payload?.data?.error : '';
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.summaryStatus = null;
      state.addLetterStatus = null;
      state.isLoading = false;
      state.clientCodeData = {};
      state.addSuccessMsg = null;
    },
    resetRecordStatus: (state, action) => {
      state.addLetterdataStatus = null;
      state.addSuccessMsg = null;
    },
    resetData: (state, action) => {
      state.clientCodeData = {};
      state.summaryData = {};
      state.letterGroupDropdownData = [];
    },
    resetUsageData: (state, action) => {
      state.maintainLetterUsageData = {};
    },
    resetLetterNumberData: (state) => {
      state.letterNumberDetails = {};
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.summaryMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.letterMaintainPrintStatus = null;
    },
    getCompanyCodeData: (state, action) => {
      state.companyCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    getClietCodeData: (state, action) => {
      state.clientCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    setLetterMaintainPrintData: (state, action) => {
      state.letterMaintainPrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchSummaryData,
  postLetterData,
  fetchSummaryLetterData,
  fetchSuccess,
  fetchError,
  resetMessage,
  resetStatus,
  getCompanyCodeData,
  getClietCodeData,
  resetData,
  postLetterNumberData,
  resetLetterNumberData,
  getLetterGroupData,
  setLetterMaintainPrintData,
  setMaintainLetterUsageData,
  resetUsageData,
  fetchAddSuccess,
  resetRecordStatus,
  postLetterTypeAddData,
} = slice.actions;

export const fetchSummary = (Number) => {
  return (dispatch) => {
    dispatch(fetchStart());

    httpGet(`lettermaintenance/find/letterparameter/${Number}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSummaryData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getLetterGroupDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/groupcodeanddescription`)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data?.status && data.status === 200) {
          dispatch(getLetterGroupData(data?.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchMaintainLetterUsageData = (rowData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/usage/letterdefinition/${rowData?.letterCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setMaintainLetterUsageData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const postLetter = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/save/letterparameter`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postLetterTypeAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postLetterData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchSummaryLetters = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/summary`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSummaryLetterData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getClientCode = ({companyType}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`client/clientnumber/${companyType}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClietCodeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postLetterNumber = (letternumber, data) => {
  return (dispatch) => {
    httpPost(`lettermaintenance/search/letternumber/${letternumber}`, data, {})
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(postLetterNumberData(data.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const printLettermaintain = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/print/letterSummary`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintLetterMaintain({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
function download(link) {
  const element = document.createElement('a');
  element.setAttribute('href', link);
  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}
export const postPrintLetterMaintain = (payload, postRuleGroupData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/generateurlprintletter`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setLetterMaintainPrintData(postRuleGroupData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const ResetLetterNumber = () => {
  return (dispatch) => {
    dispatch(resetLetterNumberData());
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
export const ResetClientCode = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const ResetUsageData = () => {
  return (dispatch) => {
    dispatch(resetUsageData());
  };
};
export const ResetAddRecord = () => {
  return (dispatch) => {
    dispatch(resetRecordStatus());
  };
};
export const getCompanyCode = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [COMPANY_TYPE],
      }),
    ])
      .then((data) => {
        if (data && data[0].status && data[0].status === 200) {
          dispatch(getCompanyCodeData(data[0]?.data));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
